"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxRulesServiceStub = void 0;
const ok = (payload) => ({ status: true, message: "success", payload });
const stubRuleSet = {
    _id: "taxrulesets-stub",
    companyId: "company-stub",
    status: "draft",
    version: 1,
    countryCode: "AU",
    rules: [],
    treatyCodes: [],
    createdAt: "2026-06-11T00:00:00.000Z",
    updatedAt: "2026-06-11T00:00:00.000Z",
};
class TaxRulesServiceStub {
    async getTaxRules() {
        return ok({ draft: null, published: null });
    }
    async createTaxRuleSet(_companyId, body) {
        return ok({
            ...stubRuleSet,
            countryCode: body.countryCode,
            rules: body.rules ?? [],
            treatyCodes: body.treatyCodes ?? [],
        });
    }
    async updateTaxRuleDraft(_companyId, body) {
        return ok({ ...stubRuleSet, rules: body.rules, treatyCodes: body.treatyCodes });
    }
    async validateTaxRuleDraft() {
        return ok({ isMece: true, errors: [] });
    }
    async publishTaxRuleDraft() {
        return ok({ ...stubRuleSet, status: "published", publishedAt: "2026-06-11T00:00:00.000Z" });
    }
    // The stub keeps the immediate-publish shape (approvals disabled) so existing consumers see the
    // published rule set; the live client returns ISubmitForApprovalResult when approval is enabled.
    async discardTaxRuleDraft() {
        return ok(null);
    }
    async getTaxRuleSetHistory() {
        return ok({ total: 0, items: [] });
    }
    async getDistributionTaxOutcomes() {
        return ok([]);
    }
}
exports.TaxRulesServiceStub = TaxRulesServiceStub;
//# sourceMappingURL=TaxRulesServiceStub.js.map